
import { computed, onMounted, ref } from 'vue';
import Button from 'primevue/button';
import { useAuthStore } from '../stores/auth';
import Knob from 'primevue/knob';
import Card from 'primevue/card';
import { storeToRefs } from 'pinia';
import PopupMainNavbar from '../components/navbar/PopupMainNavbar.vue';
import { showVuePopup } from '../utils/showVuePopup';
import ChangePassword from './ChangePassword.vue';
import Entertainment from './Entertainment.vue';
import PromotionList from './PromotionList.vue';
import WalletDeposit from './WalletDeposit.vue';
import { formatCurrency } from '../utils/currency';
import { useToast } from 'primevue/usetoast';
import WalletUpdate from './WalletUpdate.vue';
import { useSession } from '../stores/session';
import CopyButton from '../components/CopyButton.vue';

export default {
	name: 'Profile',
	methods: { formatCurrency },
	components: {
		Knob,
		Card,
		Button,
		PopupMainNavbar,
		CopyButton,
	},
	setup() {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);

		const session = useSession();

		const toast = useToast();

		const isBankUpdated = computed(() => !!profile.value?.customerBankName && !!profile.value?.customerBankAccount);
		const isP2PUpdated = computed(() => !!profile.value?.peer2PayUID && profile.value.isSyncPeer2Pay);

		const btnClickWalletDepositAuto = async () => {
			session.set('navbar_primary', 'wallet');
			session.set('navbar_sub', 'wallet:deposit')
			await showVuePopup(WalletDeposit);
		}

		const btnClickChangePassword = async () => {
			await showVuePopup(ChangePassword);
		}
		const btnClickEntertainment = async () => {
			await showVuePopup(Entertainment);
		}

		const btnClickPromotionList = async () => {
			session.set('navbar_primary', 'promotion');
			session.set('navbar_sub', 'promotion:list');
			await showVuePopup(PromotionList);
		}

		const btnClickUpdateBank = async () => {
			session.set('navbar_primary', 'wallet');
			session.set('navbar_sub', 'wallet:update');
			await showVuePopup(WalletUpdate, {tabs: 'bank'})
		}

		const btnClickUpdateP2p = async () => {
			session.set('navbar_primary', 'wallet');
			session.set('navbar_sub', 'wallet:update');
			await showVuePopup(WalletUpdate, {tabs: 'p2p'})
		}

		// EXP: แสดงค่า exp จริงจาก response, ring เทียบ totalExp (เดิม ref(0) ค้าง = โชว์ 0 เสมอ)
		const knobValue = computed<number>(() => profile.value?.rank?.exp ?? 0)
		const knobMax = computed<number>(() => {
			const total = profile.value?.rank?.totalExp ?? 0
			return total > 0 ? total : 100
		})

		onMounted(() => {
			auth.fetchData()
		})

		return {
			auth,
			profile,
			knobValue,
			knobMax,
			isBankUpdated,
			isP2PUpdated,
			btnClickWalletDepositAuto,
			btnClickChangePassword,
			btnClickEntertainment,
			btnClickPromotionList,
			btnClickUpdateBank,
			btnClickUpdateP2p,
		};
	},
};
